//
// Typescript is missing signDisplay prop
//
interface Options extends Intl.NumberFormatOptions {
  signDisplay?: 'auto' | 'never' | 'always' | 'exceptZero';
}

export const formatCurrency = (value: number, options?: Options) => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: value % 1 === 0 ? 0 : 2,
    maximumFractionDigits: value % 1 === 0 ? 0 : 2,
    ...options,
  }).format(value);
};

export const formatPercentage = (value: number, options?: Intl.NumberFormatOptions) => {
  return new Intl.NumberFormat('en-US', { style: 'percent', ...options }).format(value);
};
